import dayjs from 'dayjs';

const DATE_FORMAT = 'YYYY-MM-DD';
const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';

export const formatDate = (value?: string | null, format = DATE_FORMAT) => {
  if (!value) return '-';
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format(format) : '-';
};

export const formatDateTime = (
  value?: string | null,
  format = DATETIME_FORMAT,
) => {
  if (!value) return '-';
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format(format) : '-';
};
